let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8zrOr")).then(() => parcelRequire('dtTJ9'));